module.exports = __webpack_public_path__ + "img/MoonSword 4b.b990a3ee.png";